module.exports = __webpack_public_path__ + "static/staff-5-7f425e96993bd281b5b57b70deb35c5b.png";